import './badge.scss';
import React from 'react';

export function Badge(): JSX.Element {
  return <div className="badge" />;
}
